import {MenuProps} from '@material-ui/core/Menu';
import {InsightsThemeTokens} from './insightsTheme';

export interface ThemedSelectMenuOptions {
  /** Use for Select inside Modal (stacking / focus) */
  inModal?: boolean;
}

export function getThemedSelectMenuProps(
  theme: InsightsThemeTokens,
  options?: ThemedSelectMenuOptions
): Partial<MenuProps> {
  return {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    ...(options?.inModal ? {disablePortal: true} : {}),
    PaperProps: {
      style: {
        backgroundColor: theme.cardBg,
        color: theme.text,
        borderRadius: '10px',
        border: '1px solid',
        borderColor: theme.grey,
        maxHeight: '55vh',
      },
    },
    MenuListProps: {
      style: {
        backgroundColor: theme.cardBg,
        color: theme.text,
      },
    },
  };
}
